import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SharedPagination from "../../modules/common/sharedPagination";
import "./style.css";
import { errorMessage } from "../../utlis/common";
import { CommonTable } from "../../modules/common/table/Table";
import { FetchAnalyticsList } from "../../redux/features/Analytics/analyticsAction";
import { analyticsListColumns } from "../../modules/common/table/columns/_analyticsListColumns";
import { AnalyticsModal } from "./AnalyticsDetailsMoadal";

const formatDate = (date: Date) => {
  return date.toISOString().split("T")[0];
};

const AnalyticsPage = () => {
  const dispatch: any = useDispatch();
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 10;
  const today = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);
  const states = useSelector((state: any) => state.analyticsSlice);
  const analyticsList = states?.analytics || [];
  const totalRecord = states?.totalRecord || 0;
  const [startDate, setStartDate] = useState(formatDate(oneMonthAgo));
  const [endDate, setEndDate] = useState(formatDate(today));
  const totalPages = Math.ceil(totalRecord / limit);

  useEffect(() => {
    const fetchAnalytics = async () => {
      setLoading(true);
      try {
        await dispatch(
          FetchAnalyticsList({
            page: currentPage,
            limit,
            start: startDate || undefined,
            end: endDate || undefined,
          })
        );
      } catch (error) {
        console.error("Failed to fetch analytics:", error);
        errorMessage("Failed to load analytics");
      } finally {
        setLoading(false);
      }
    };

    fetchAnalytics();
  }, [currentPage, startDate, endDate, dispatch]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleFilter = () => {
    setCurrentPage(1); // reset to first page when filtering
  };

  return (
    <>
      <div className="order-status-container">
        <div className="inventory-header">
          <h2 className="page-title">Analisi</h2>

          {/* Date range filter */}
          <div className="date-range-filter" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <label>
              Data di inizio:
              <input
                className="form-control"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </label>
            <label>
              Data di fine:
              <input
                type="date"
                className="form-control"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </label>
            {/* <button onClick={handleFilter}>Filter</button> */}
          </div>
        </div>

        <div className="orderListTable">
          {loading ? (
            <p className="loading-text">Caricamento analisi...</p>
          ) : analyticsList?.length > 0 ? (
            <CommonTable data={analyticsList} columns={analyticsListColumns} />
          ) : (
            <p className="no-orders">Nessuna analisi disponibile</p>
          )}
        </div>

        <AnalyticsModal />

        {totalRecord > 10 && (
          <SharedPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </>
  );
};

export default AnalyticsPage;
